'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import ProjectStatusModalChangeController from './controller/projectStatusModalChange';
import ProjectProgressDirective from './directive/projectProgress';

export default angular.module('investmentProject.project.progress', [])
                      .controller('ProjectStatusModalChangeController', ProjectStatusModalChangeController)
                      .directive('projectProgress', ProjectProgressDirective)
    .name;
